import { motion } from "framer-motion";
import { useState } from "react";
import { useLocomotiveScroll } from "react-locomotive-scroll";
import "./NavOverlay.scss";

const NavOverlay = ({ setShowOverlay, setCursorVariant }) => {
  const [backImage, setbackimage] = useState("assets/n.gif");
  const { scroll } = useLocomotiveScroll();
  const handleScroll = (id) => {
    let elem = document.querySelector(id);
    scroll.scrollTo(elem, {
      offset: "-100",
      duration: "2000",
      easing: [0.25, 0.0, 0.35, 1.0],
    });
    setShowOverlay(false);
  };
  const objectEnter = () => {
    setCursorVariant("text");
  };
  const objectLeave = () => {
    setCursorVariant("default");
  };
  const updateBackground = (which) => {
    switch (which) {
      case "home":
        setbackimage("assets/n1.png");
        break;
      case "about":
        setbackimage("assets/n2.gif");
        break;
      case "project":
        setbackimage("assets/n3.gif");
        break;
      case "contact":
        setbackimage("assets/n4.png");
        break;
      case "default":
        setbackimage("assets/n.gif");
        break;
    }
  };
  return (
    <motion.div
      key="navOverlay"
      initial={{ y: "100%", scale: 1, opacity: 0 }}
      animate={{ y: 0, scale: 1, opacity: 1 }}
      exit={{ y: "100%", transition: { duration: 0.65 } }}
      transition={{
        duration: 0.65,
        ease: "backOut",
      }}
      className="overlay-wrapper"
    >
      <div
        className="back-image"
        style={{ backgroundImage: `url(${backImage})` }}
      ></div>
      <motion.div className="overlay-links">
        <div
          className="link-name"
          onClick={() => handleScroll("#home")}
          onMouseEnter={() => {
            objectEnter();
            updateBackground("home");
          }}
          onMouseLeave={() => {
            objectLeave();
            updateBackground("default");
          }}
        >
          Home
        </div>
        <div
          className="link-name"
          onClick={() => handleScroll("#about")}
          onMouseEnter={() => {
            objectEnter();
            updateBackground("about");
          }}
          onMouseLeave={() => {
            objectLeave();
            updateBackground("default");
          }}
        >
          About
        </div>
        <div
          className="link-name"
          onClick={() => handleScroll("#project")}
          onMouseEnter={() => {
            objectEnter();
            updateBackground("project");
          }}
          onMouseLeave={() => {
            objectLeave();
            updateBackground("default");
          }}
        >
          Project
        </div>
        <div
          className="link-name"
          onClick={() => handleScroll("#contact")}
          onMouseEnter={() => {
            objectEnter();
            updateBackground("contact");
          }}
          onMouseLeave={() => {
            objectLeave();
            updateBackground("default");
          }}
        >
          Contact
        </div>
      </motion.div>
      <div className="overlay-info">
        <p>Social Handles</p>
        <div className="social-links-group">
          <a
            href="https://www.linkedin.com/in/v-man/"
            target="_blank"
            rel="noreferrer"
          >
            <div className="social-links">LinkedIn</div>
          </a>
          <a
            href="https://github.com/vars7899"
            target="_blank"
            rel="noreferrer"
          >
            <div className="social-links">Github</div>
          </a>
          <a
            href="https://www.instagram.com/vaibhav_dman/"
            target="_blank"
            rel="noreferrer"
          >
            <div className="social-links">Instagram</div>
          </a>
        </div>
      </div>
    </motion.div>
  );
};

export default NavOverlay;
